import MobileDetect from 'mobile-detect';

const deviceCheck = () => {
  const mobileDetect = new MobileDetect(window.navigator.userAgent);

  const clientApplication = 'Web';
  let clientPlatform = 'Other';

  let clientDeviceType = 'Desktop';

  if (mobileDetect.phone()) {
    clientDeviceType = `Mobile:${mobileDetect.phone()}`;

    if (mobileDetect.os()) {
      clientPlatform = mobileDetect.os();
    }
  } else if (mobileDetect.tablet()) {
    clientDeviceType = `Tablet:${mobileDetect.tablet()}`;

    if (mobileDetect.os()) {
      clientPlatform = mobileDetect.os();
    }
  } else {
    if (window.navigator && window.navigator.platform) {
      clientPlatform = window.navigator.platform;
    }
  }

  return {
    clientApplication,
    clientDeviceType,
    clientPlatform,
  };
};

export default deviceCheck;
